/* eslint-disable max-len */
import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const RestaurantIcon: FC<IconProps> = props => (
  <BaseIcon {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M7 3H13V11Q13 14 11 14V29H9V14Q7 14 7 11V3ZM8.5 3H9.5V11H8.5ZM10.5 3H11.5V11H10.5Z"
    />
    <path d="M19 29V3H20C24 8 23 13 21 14V29Z" />
  </BaseIcon>
);
